import axios from "axios";
import { API_BASE_URL } from "../config/config";

// const currentDomain = window.location.hostname; // Örn: "localhost" veya "www.example.com"

// const API_BASE_URL =
//   currentDomain === "localhost" ||
//   currentDomain === "127.0.0.1" ||
//   currentDomain === "aiconnect.com.tr" ||
//   currentDomain === "demo.aiconnect.com.tr"
//     ? "https://apis.aiconnect.com.tr"
//     : `https://apis.${currentDomain}`;

const ReportHistoryServices = {
  getreport: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      startDate: data.startDate,
      endDate: data.endDate,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      did: data.did,
      agent: data.agent,
      callreasonId: data.callreasonId,
      callstatusId: data.callstatusId,
      target: data.target,
      isEvaluation: data.isEvaluation,
      disposition: data.disposition,
      announcement: data.announcement,
      direction: data.direction,
    });
    return axios.get(`${API_BASE_URL}/reporthistory/list?${params.toString()}`);
  },
  getreportdetail: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
    });
    return axios.get(`${API_BASE_URL}/reporthistory/list?${params.toString()}`);
  },
  //note için
  getRecordingData: (data) => {
    return axios.post(`${API_BASE_URL}/recordingnote/getRecordingData`, data);
  },
  insert: (data) => {
    return axios.post(`${API_BASE_URL}/recordingnote/insert`, data);
  },
  downloadAll: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      startEndDate: data.startEndDate,
    });
    return axios.get(
      `${API_BASE_URL}/reporthistory/reportDownloadAll?${params.toString()}`
    );
  },
  getSpecialData: (data) => {
    return axios.post(`${API_BASE_URL}/reporthistory/getSpecialData`, data);
  },
  listDetail: (data) => {
    const params = new URLSearchParams({
      start: data.start,
      size: data.size,
      filters: data.filters,
      globalFilter: data.globalFilter,
      sorting: data.sorting,
      accountcode: data.accountcode,
      token: data.token,
      userID: data.userID,
      linkedid: data.linkedId,
    });
    return axios.get(
      `${API_BASE_URL}/reporthistory/listDetail?${params.toString()}`
    );
  },
};

export default ReportHistoryServices;
